import { render } from "./Invullijst.vue?vue&type=template&id=135b7b1a&scoped=true"
import script from "./Invullijst.vue?vue&type=script&lang=js"
export * from "./Invullijst.vue?vue&type=script&lang=js"

import "./Invullijst.vue?vue&type=style&index=0&id=135b7b1a&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135b7b1a"]])

export default __exports__